module.exports = __webpack_public_path__ + "static/media/Frank-Diez.27566cf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leadership/Frank-Diez.jpg
// module id = 295
// module chunks = 0